import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202508: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202508",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-08-01",
  endDate: "2025-08-31",
  impressions: 91832,
  clicks: 2046,
  adsSpendDollars: 4191,
  budgetDollars: 4700,
  salesDollars: 14216,
  bestEstimateRoas: 3.39,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.89,
  newCustomersAcquired: 30,
  reorderConversions: 5,
  dataAvailableAtDate: "2025-09-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
